import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import { connect } from 'react-redux'
import { push } from 'react-router-redux'

import { toCssClass, toRoman } from 'helpers'
import { BUILDING_TITLES, COMMAND_CENTER_TITLE } from 'helpers/i18n'

import ProductionProgress from 'components/ProductionProgress/ProductionProgress'
import KineticScrolling from './components/KineticScrolling/KineticScrolling'

import { playCarouselClickSound, playCarouselHoverSound } from 'state/actions/sounds'

import { BUILDING } from 'urls'
import {
    CAROUSEL_BUILDING_TOOLTIP_ID,
    CAROUSEL_COMMAND_CENTER_TOOLTIP_ID,
    COMMAND_CENTER_ID,
} from 'constants'
import {
    MAX_BUILDINGS_COUNT,
    CAROUSEL_ITEM_WIDTH,
} from './constants'

import styles from './BuildingsCarousel.scss'
import { getSortedProductionReserves } from 'helpers/reserves'

const COMMAND_CENTER = 'COMMAND_CENTER'

export class BuildingsCarousel extends React.Component {
    static propTypes = {
        buildings: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.oneOfType([
                PropTypes.number,
                PropTypes.string,
            ]).isRequired,
            type: PropTypes.string.isRequired,
            level: PropTypes.number.isRequired,
            reserveType: PropTypes.string,
            reserveQueue: PropTypes.arrayOf(PropTypes.object),
        })).isRequired,
        selectedBuildingId: PropTypes.oneOfType([
            PropTypes.number,
            PropTypes.string,
        ]).isRequired,
        playCarouselClickSound: PropTypes.func.isRequired,
        playCarouselHoverSound:PropTypes.func.isRequired,
        pushState: PropTypes.func.isRequired,
    }

    state = {
        dragging: false,
    }

    trackCarouselState = ({ dragging }) => {
        this.setState({ dragging })
    }

    getBuildingsList() {
        const buildingsList = this.props.buildings.map(building => {
            const isActive = (building.id === this.props.selectedBuildingId)
            const imageClassName = classNames(
                styles.image,
                styles[`image__${toCssClass(building.type)}`],
                styles[`image__level-${building.level}`]
            )
            let progressBar
            if (building.reserveType) {
                progressBar = (
                    <div className={styles.progress}>
                        <ProductionProgress
                            reserveQueue={building.reserveQueue}
                            simplified
                        />
                    </div>
                )
            }

            const handleClick = () => {
                this.props.playCarouselClickSound()
                this.props.pushState(BUILDING(building.id))
            }

            const handleHover = () => this.props.playCarouselHoverSound()

            const itemClassName = classNames(styles.item, {
                [styles.item__active]: isActive,
            })

            const buildingTitle = building.type === COMMAND_CENTER ?
                COMMAND_CENTER_TITLE :
                BUILDING_TITLES[building.type]

            const buildingTooltipId = building.type === COMMAND_CENTER ?
                CAROUSEL_COMMAND_CENTER_TOOLTIP_ID :
                `${CAROUSEL_BUILDING_TOOLTIP_ID}_${building.type}`

            return (
                <div
                    className={itemClassName}
                    key={`buildingItem__${building.id}`}
                    onClick={(this.state.dragging || isActive) ? null : handleClick}
                    onMouseEnter={handleHover}
                    data-tip
                    data-for={buildingTooltipId}
                >
                    <div className={styles.background} />
                    <div className={styles.overlay} />
                    {progressBar}
                    <div className={styles.content}>
                        <span className={styles.level}>{toRoman(building.level)}</span>
                        <div className={imageClassName} />
                        <p className={styles.title}>{buildingTitle}</p>
                    </div>
                </div>
            )
        })

        return buildingsList
    }

    render() {
        const emptyItemsCount = MAX_BUILDINGS_COUNT - this.props.buildings.length
        const emptySlots = Array.from({ length: emptyItemsCount }, (item, index) => {
            const className = classNames(styles.item, styles.item__empty)
            return (
                <div className={className} key={`emptyItem__${index}`}>
                    <div className={styles.background}/>
                </div>
            )
        })
        const activeItemIdx = this.props.buildings.findIndex(building => building.id === this.props.selectedBuildingId)
        return (
            <div className={styles.base}>
                <KineticScrolling
                    snap={CAROUSEL_ITEM_WIDTH}
                    activeItemIdx={activeItemIdx}
                    trackState={this.trackCarouselState}
                >
                    {this.getBuildingsList()}
                    {emptySlots}
                </KineticScrolling>
            </div>
        )
    }
}

export const mapStateToProps = (state, { selectedBuildingId }) => {
    const { settings, stronghold } = state
    const commandCenter = {
        id: COMMAND_CENTER_ID,
        type: COMMAND_CENTER,
        level: stronghold.level,
    }
    let buildings = Object.keys(state.buildings).map(buildingId => {
        const { id, type, level } = state.buildings[buildingId]
        const reserveType = settings.buildings[type].reserve_type
        const reserveQueue = getSortedProductionReserves(state.clanReserves[reserveType])
        return { id, type, level, reserveType, reserveQueue }
    })
    buildings = [ commandCenter, ...buildings]

    return {
        buildings,
        selectedBuildingId,
    }
}

export const mapDispatchToProps = {
    playCarouselClickSound,
    playCarouselHoverSound,
    pushState: push,
}

export default connect(mapStateToProps, mapDispatchToProps)(BuildingsCarousel)



// WEBPACK FOOTER //
// ./containers/BuildingsCarousel/BuildingsCarousel.jsx